import React from "react";
import {
  Box,
  Button,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import TextFieldsRoundedIcon from "@mui/icons-material/TextFieldsRounded";
import PaletteRoundedIcon from "@mui/icons-material/PaletteRounded";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import FormatSizeRoundedIcon from "@mui/icons-material/FormatSizeRounded";
import ImageRoundedIcon from "@mui/icons-material/ImageRounded";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import VisibilityOffRoundedIcon from "@mui/icons-material/VisibilityOffRounded";

const TOOLS = [
  { id: "content", label: "Textos", icon: TextFieldsRoundedIcon },
  { id: "colors", label: "Colores", icon: PaletteRoundedIcon },
  { id: "style", label: "Estilo", icon: TuneRoundedIcon },
  { id: "type", label: "Tipografía", icon: FormatSizeRoundedIcon },
  { id: "image", label: "Imágenes", icon: ImageRoundedIcon },
];

export default function LandingSegmentToolbar({
  sectionId,
  label,
  enabled,
  canToggle,
  onToggle,
  onOpenTool,
}) {
  const compact = useMediaQuery("(max-width:760px)");

  return (
    <Box
      className="landing-segment-toolbar"
      onClick={(event) => event.stopPropagation()}
      sx={{
        position: "absolute",
        top: { xs: 8, sm: 10 },
        right: { xs: 8, sm: 10 },
        left: { xs: 8, sm: "auto" },
        zIndex: 45,
        display: "flex",
        justifyContent: "flex-end",
        pointerEvents: "auto",
      }}
    >
      <Stack
        direction="row"
        spacing={0.45}
        alignItems="center"
        sx={{
          maxWidth: "100%",
          p: 0.55,
          borderRadius: 999,
          bgcolor: "rgba(25,36,47,.94)",
          color: "#fff",
          boxShadow: "0 12px 36px rgba(25,36,47,.28)",
          backdropFilter: "blur(12px)",
          overflowX: "auto",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
        }}
      >
        {!compact ? (
          <Typography
            variant="caption"
            noWrap
            sx={{ pl: 1, pr: 0.5, maxWidth: 180, fontWeight: 950 }}
          >
            {label}
          </Typography>
        ) : null}

        {TOOLS.map(({ id, label: toolLabel, icon: Icon }) =>
          compact ? (
            <Tooltip title={toolLabel} key={id}>
              <IconButton
                size="small"
                aria-label={`${toolLabel} de ${label}`}
                onClick={() => onOpenTool(sectionId, id)}
                sx={{ color: "#fff", bgcolor: "rgba(255,255,255,.08)" }}
              >
                <Icon fontSize="small" />
              </IconButton>
            </Tooltip>
          ) : (
            <Button
              key={id}
              size="small"
              startIcon={<Icon fontSize="small" />}
              onClick={() => onOpenTool(sectionId, id)}
              sx={{
                minWidth: 0,
                px: 1.05,
                color: "#fff",
                borderRadius: 999,
                textTransform: "none",
                fontWeight: 850,
                "&:hover": { bgcolor: "rgba(255,255,255,.12)" },
              }}
            >
              {toolLabel}
            </Button>
          )
        )}

        {canToggle ? (
          <Tooltip title={enabled ? "Ocultar sección" : "Mostrar sección"}>
            <IconButton
              size="small"
              aria-label={enabled ? "Ocultar sección" : "Mostrar sección"}
              onClick={() => onToggle(!enabled)}
              sx={{
                color: enabled ? "#fff" : "#F9B4A6",
                bgcolor: "rgba(255,255,255,.08)",
              }}
            >
              {enabled ? (
                <VisibilityRoundedIcon fontSize="small" />
              ) : (
                <VisibilityOffRoundedIcon fontSize="small" />
              )}
            </IconButton>
          </Tooltip>
        ) : null}
      </Stack>
    </Box>
  );
}
